import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import EcGrid from "@/components/widgets/EcGrid.vue";
import { interpret } from "xstate";
import DeleteComponent from "@/components/deleteComponent.vue";
import { GridOptionModel } from "@/store/models/shared/gridOption";
import { StateModule } from "@/store/modules/state.module";
import { StateSaveModel } from "@/store/models/state/stateSaveDTO";
import StateUpsertComponent from "./components/StateUpsertComponent.vue";
import statesListingMachine from "./machines/stateListingMachine";
let StatesListing = /** @class */ (() => {
    let StatesListing = class StatesListing extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "States";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Masters",
                    href: "#",
                },
                {
                    text: "States",
                    active: true,
                },
            ];
            this.isGridLoading = false;
            this.initialPage = 1;
            this.initialPageSize = 10;
            this.searchData = new GridOptionModel();
            this.stateId = "";
            this.componentTitle = "";
            this.buttonName = "";
            this.stateItem = new StateSaveModel();
            this.columns = [
                {
                    field: "stateName",
                    label: "State Name",
                    thClass: "state-name",
                    filterOptions: {
                        enabled: true,
                        placeholder: "Enter State",
                        autoComplete: "off",
                    },
                    sortable: true,
                },
                {
                    field: "stateCode",
                    label: "Code",
                    thClass: "state-code",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: "Enter Code",
                        autoComplete: "off",
                    },
                },
                {
                    field: "actions",
                    label: "Actions",
                    thClass: "master-action",
                    sortable: false,
                },
            ];
            this.serverParams = {
                columnFilters: {},
                sort: {
                    field: "stateName",
                    type: "asc",
                },
                page: 1,
                pageSize: 10,
            };
            this.totalCount = 0;
            //   MACHINE
            this.machine = statesListingMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        send(event) {
            this.machineService.send(event);
        }
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        }
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        }
        onPerPageChange(params) {
            this.updateParams({
                pageSize: params.currentPerPage,
                page: this.initialPage,
            });
            this.loadItems();
        }
        onSortChange(params) {
            this.updateParams({ sort: params[0], page: this.initialPage });
            this.loadItems();
        }
        onColumnFilter(params) {
            this.updateParams({
                columnFilters: params.columnFilters,
                page: this.initialPage,
            });
            this.loadItems();
        }
        loadItems() {
            this.isGridLoading = true;
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            var searchData = {
                page: this.serverParams.page,
                pageSize: this.serverParams.pageSize,
                sort: this.serverParams.sort,
                columnFilters: filters,
            };
            this.machineService.send({ type: "GETTING_STATES", searchData: searchData });
        }
        onRowClick() {
            return "";
        }
        get rows() {
            return StateModule.states;
        }
        get isAnyFilterApplied() {
            return this.columnFilters.length != 0 && this.columnFilters.some((x) => x.value);
        }
        get totalStates() {
            return StateModule.totalCount;
        }
        get columnFilters() {
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            return filters;
        }
        clearFilter() {
            this.serverParams.columnFilters = {};
            // this.serverParams.page = this.initialPage;
            var ecgrid = this.$refs.ecgrid;
            ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters = {};
            this.loadItems();
        }
        showStateAddModal() {
            this.stateItem = new StateSaveModel();
            this.componentEvent("Add New State", "Save");
            this.machineService.send({ type: "ADD_STATE" });
        }
        stateModal() {
            let stateComponent = this.$refs["stateComponent"];
            stateComponent.showModal();
        }
        showEditStateModal(id) {
            const value = this.rows.find((item) => item.id == id);
            if (value) {
                const { id, stateName: stateName, stateCode: stateCode } = value;
                this.stateItem = { id, stateName, stateCode };
                this.componentEvent("Edit State", "Update");
                this.machineService.send({ type: "EDIT_STATE" });
            }
        }
        saveState(state) {
            if (this.state.hasTag("showAddStateModal")) {
                this.machineService.send({ type: "ADDING_STATE", state: state });
            }
            else {
                this.machineService.send({ type: "UPDATING_STATE", state: state });
            }
        }
        stopLoading() {
            let stateComponent = this.$refs["stateComponent"];
            stateComponent.stopLoading();
        }
        loading() {
            let stateComponent = this.$refs["stateComponent"];
            stateComponent.loading();
        }
        componentEvent(title, button) {
            this.componentTitle = title;
            this.buttonName = button;
            this.stateModal();
        }
        showDeleteStateModal(id) {
            const isPageChanged = this.rows.length == 1 && this.serverParams.page != 1 ? true : false;
            this.stateId = id;
            this.machineService.send({ type: "DELETE_STATE", ispageChanged: isPageChanged });
        }
        deleteState() {
            this.machineService.send({ type: "DELETING_STATE", stateId: this.stateId });
        }
        cancel() {
            this.machineService.send({ type: "CANCEL_STATE" });
        }
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                if (this.state.matches("loadedStates")) {
                    this.totalCount = this.totalStates;
                    this.isGridLoading = false;
                }
                if ((this.state.matches("gettingStates") && previousState.matches("updatingState")) || (this.state.matches("gettingStates") && previousState.matches("addingState"))) {
                    this.stopLoading();
                }
                if ((this.state.matches("editState") && previousState.matches("updatingState")) || (this.state.matches("addState") && previousState.matches("addingState"))) {
                    this.loading();
                }
                if (this.state.matches("gettingStates") && previousState.matches("deletingState")) {
                    this.isGridLoading = true;
                    if (this.state.context.ispageChanged) {
                        this.serverParams.page = this.serverParams.page - 1;
                    }
                }
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    StatesListing = __decorate([
        Component({
            name: "StatesListing",
            components: {
                Layout,
                PageHeader,
                EcGrid,
                DeleteComponent,
                StateUpsertComponent,
            },
        })
    ], StatesListing);
    return StatesListing;
})();
export default StatesListing;
